export default "__VITE_ASSET__BOoL8rCy__"